import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AllocationType, PlanningAction } from 'src/app/modules/settings/planning-sheet/models/update-planning-params';

interface PlanningData {
  planData?: any[]; // Array of items for planning data
  planDateData?: any; // Object containing month and year
  planHolidayData?: any[]; // Array of holiday objects
  planStaffData?: any[]; // Array of staff data
  planDeptData?: any;
  dutyConfigData?: any[];
  planningSheetStatus?: PlanningAction | null;
  planDatePickerData?:any;
  allowedMonth?: any;
  planningView?:string;
  planPlanReportStaffData?:any;
  planMultiDeptData?:any
}

interface ApiToCall{
  scheduleApi?:boolean,
  managersApi?:boolean,
  combinedApi?:boolean,
  holidayApi?:boolean,
  allowedForMonthsApi?:boolean
}

@Injectable({
  providedIn: 'root',
})
export class PlanningDataService {
  planningData: any = null;
  planDataAvlbl: boolean = false
  apiToCallDataAvbl: boolean = false
  apiToCallData: any = null
  selRouterLink:any
  selRouterLinkAvlbl:boolean = false
  isPrintView: boolean = false;
  canPrePlan: boolean = false;
  planMultiDeptData: [];
  private defaultPlanningData: PlanningData = {
    planData: [],
    planDateData: {},
    planHolidayData: [],
    planStaffData: [],
    planDeptData: {},
    dutyConfigData: [],
    planningSheetStatus: null,
  };
  constructor(private translate: TranslateService) {
  }
  private isLocalStorageAvailable() {
    let locAvl = typeof window !== 'undefined' && !!window.localStorage;
    if (locAvl) {
      let planningData:any = sessionStorage.getItem('planningSheetData');
      let apiToCallData:any = sessionStorage.getItem('apiToCallData');
      this.selRouterLink = sessionStorage.getItem('selRouterLink');
      this.planningData = JSON.parse(planningData);
      this.apiToCallData = JSON.parse(apiToCallData);
      this.selRouterLinkAvlbl = this.selRouterLink !== null;
      if(apiToCallData !== null){
        this.apiToCallDataAvbl = true
      }
      else{
        this.apiToCallDataAvbl = false
      }
      if (planningData !==null){
        this.planDataAvlbl = true
      }
      else{
        this.planDataAvlbl = false
      }
    }
  }

    // Method to set planning data
  setPlanLimitData(data: number) {
    sessionStorage.setItem('planLimitData', JSON.stringify(data));
  }

  getPlanLimitData() {
    let locAvl = typeof window !== 'undefined' && !!window.sessionStorage;
    if (locAvl) {
      let planLimitData: any = sessionStorage.getItem('planLimitData');
      return planLimitData;
    }
  }
  // Method to set planning data
  setPlanSheetData(data: PlanningData) {
    // Store planning data in localStorage as a string
    const currentData = this.getPlanSheetData();
    // Merge new data into current data, replacing existing keys or adding new ones
    const updatedData = { ...currentData, ...data };
    sessionStorage.setItem('planningSheetData', JSON.stringify(updatedData));
  }

  getPlanSheetData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }
  // Method to set planning data
  setPlanData(data: any) {
    // Store planning data in localStorage as a string
    this.setPlanSheetData({ planData: data });
  }

  // Method to get plan data
  getPlanData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }
    // Method to set date data
  setPlanReportStaffData(data: any) {
    // Store date picker data
    this.setPlanSheetData({ planPlanReportStaffData: data });
  }

  getPlanReportStaffData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planPlanReportStaffData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

    // Method to set date data
  setDatePickerData(data: Object) {
    // Store date picker data
    this.setPlanSheetData({ planDatePickerData: data });
  }

  getDatePickerData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planDatePickerData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  // Method to set date data
  setAllowedMonthData(data: Object) {
    // Store date picker data
    this.setPlanSheetData({ allowedMonth: data });
  }

  getAllowedMonthData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.allowedMonth;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

   // Method to set date data
  setPlanningView(data: string) {
    // Store date picker data
    this.setPlanSheetData({ planningView: data });
  }

  getPlanningView() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planningView;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  // Method to set holiday data
  setPlanHolidayData(data: Array<{}>) {
    // Store planning data in localStorage as a string
    this.setPlanSheetData({ planHolidayData: data });
  }

  // Method to get holiday data
  getPlanHolidayData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planHolidayData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  // Method to set multiple dept data
  setMultiDeptData(data: Object) {
    // Store planning data in localStorage as a string
    this.setPlanSheetData({ planMultiDeptData: data });
  }
 
  getMultiDeptData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData?.planMultiDeptData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  // Method to set dept data
  setDeptData(data: Object) {
    // Store planning data in localStorage as a string
    this.setPlanSheetData({ planDeptData: data });
  }

  getDeptData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData?.planDeptData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  // Method to set date data
  setDateData(data: Object) {
    // Store planning data in localStorage as a string
    this.setPlanSheetData({ planDateData: data });
  }

  getDateData() {
    this.isLocalStorageAvailable();
    if (this.planDataAvlbl) {
      const storedData = this.planningData.planDateData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

   // Method to set planning data
  setApiToCallData(data: ApiToCall) {
    // Store planning data in localStorage as a string
    const currentData = this.getApiToCallData();
    // Merge new data into current data, replacing existing keys or adding new ones
    const updatedData = { ...currentData, ...data };
    sessionStorage.setItem('apiToCallData', JSON.stringify(updatedData));
  }

  getApiToCallData() {
    this.isLocalStorageAvailable();
    if (this.apiToCallDataAvbl) {
      const storedData = this.apiToCallData;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  setScheduleApiCallData(data: boolean) {
    this.setApiToCallData({ scheduleApi: data });
  }

  setAllowedForMonthsApiCallData(data: boolean) {
    this.setApiToCallData({ allowedForMonthsApi: data });
  }

  setHolidayApiCallData(data: boolean) {
    this.setApiToCallData({ holidayApi: data });
  }

  setManagersApiCallData(data: boolean) {
    this.setApiToCallData({ managersApi: data });
  }

  setCombinedApiCallData(data: boolean) {
    this.setApiToCallData({ combinedApi: data });
  }

  clearPlanningData() {
    sessionStorage.removeItem('planningSheetData'); // Clear from localStorage
  }

  clearApiToCallData(){
    sessionStorage.removeItem('apiToCallData'); // Clear from localStorage
  }

  clearPlanLimitData() {
    sessionStorage.removeItem('planLimitData'); // Clear from localStorage
  }

  setSelRouterLink(selRouterLink:string){
    sessionStorage.setItem('selRouterLink', selRouterLink); // Persist to localStorage
  }

  getSelRouterLink(){
    this.isLocalStorageAvailable();
    if (this.selRouterLinkAvlbl) {
      const storedData = this.selRouterLink;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  clearSelRouterLink() {
    sessionStorage.removeItem('selRouterLink'); // Clear from localStorage
  }
  setCanPrePlanData(data: boolean) {
    this.canPrePlan = data
  }
  getCanPrePlanData() { 
    return this.canPrePlan  
  }
  resetCanPrePlanData() {
    this.canPrePlan = false
  }
  private activeApiCalls = 0;//to keep track of pending schedules api calls

  startApiCall() {
    this.activeApiCalls++;
  }

  endApiCall() {
    this.activeApiCalls = Math.max(0, this.activeApiCalls - 1);
  }

  hasPendingCalls(): boolean {
    return this.activeApiCalls > 0;
  }
  formatAllocationsByDayAndResource(
    allocations: any[]
  ): any[] {

    /* =========================================================
       GROUP BY DAY + RESOURCE
       ========================================================= */

    const emptyCellTooltip =
      this.translate.instant('planning_sheet.no_tooltip_data.message');

    const groupedMap = new Map<string, any[]>();

    for (const alloc of allocations) {
      const key = `${alloc.start}_${alloc.resource}`;

      if (!groupedMap.has(key)) {
        groupedMap.set(key, []);
      }

      groupedMap.get(key)!.push(alloc);
    }

    /* =========================================================
       TITLE LOGIC WITH SHIFT PRIORITY
       ========================================================= */

    const shiftPriority: Record<string, number> = {
      FIRST_HALF_DAY_DUTY: 1,
      SECOND_HALF_DAY_DUTY: 2,
      PICKET_DUTY: 3,
    };
    const validShiftTypes = new Set([
      'FIRST_HALF_DAY_DUTY',
      'SECOND_HALF_DAY_DUTY',
      'PICKET_DUTY',
      'FULL_DAY_DUTY',
      'MANAGER_DUTY',
    ]);

    for (const [, group] of groupedMap) {

      // Sort ALL allocations by shiftType priority first
      const sorted = [...group].sort((a, b) => {
        const pA = shiftPriority[a.shiftType] ?? 99;
        const pB = shiftPriority[b.shiftType] ?? 99;

        if (pA !== pB) return pA - pB;

        return (a.name || '').localeCompare(b.name || '');
      });

      const hasNonEmpty = sorted.some(
        a => a.allocationType !== AllocationType.Empty
      );

      let titleParts: string[];

      // Case 1: only EMPTY allocations
      if (!hasNonEmpty) {
        titleParts = [emptyCellTooltip];
      }
      /* ---------------------------------------------------------
         CASE 2: AT LEAST ONE NON-EMPTY → IGNORE EMPTY TOOLTIP
         --------------------------------------------------------- */
      else {
        titleParts = sorted
          .map(a => {
            // Only include NON-EMPTY allocations
            if (
              a.allocationType !== AllocationType.Empty &&
              validShiftTypes.has(a.shiftType)
            ) {
              return a.name;
            }

            return null;
          })
          .filter(Boolean);
      }

      /* ---------------------------------------------------------
         REMOVE DUPLICATES (SAFETY)
         --------------------------------------------------------- */
      const uniqueTitleParts = Array.from(new Set(titleParts));

      const combinedTitle = uniqueTitleParts.join(' | ');

      // Apply same title to all allocations in this group
      for (const alloc of group) {
        alloc.title = combinedTitle;
      }
    }

    /* =========================================================
       RETURN FORMATTED ALLOCATIONS
       ========================================================= */

    return allocations;
  }
}
